var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuyCryptoFill = function SvgBuyCryptoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.005 2.003c5.523 0 10 4.477 10 10a10 10 0 0 1-.768 3.845v-2.146h-3.404v3.265l-.485-.486-2.408 2.408 1.878 1.88a9.95 9.95 0 0 1-4.813 1.234c-5.523 0-10-4.477-10-10s4.477-10 10-10m-1 6h-1a2.5 2.5 0 0 0 0 5h4a.5.5 0 0 1 0 1h-5.5v2h2.5v2h2v-2h1a2.5 2.5 0 1 0 0-5h-4a.5.5 0 1 1 0-1h5.5v-2h-2.5v-2h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.238 14.703h-1.405v4.679l-1.486-1.487-.994.994 3.182 3.182 3.183-3.182-.994-.994-1.486 1.487z"
  })));
};
export default SvgBuyCryptoFill;